import {Injectable, signal} from '@angular/core';
import {BcGqlService, IGQLResponse, IGQLUser} from '@betterchains/bc-gql';
import {AssignmentService} from './AssignmentService';
import {first} from 'rxjs';
import {HttpResponse} from '@angular/common/http';
import {SystemService} from './SystemService';

export interface ILoadedApprovers {
  chain_id: number,
  branch_id: number,
  form_id: number,
  approvers: IGQLUser[]
  changed: boolean
}

@Injectable({providedIn: 'root'})
export class ApproversService {

  public cached: ILoadedApprovers[] = []

  public loading = signal(false)

  constructor(
    private gql: BcGqlService,
    private asvc: AssignmentService,
    private sysvc: SystemService
  ) {
  }

  public Load() {
    return new Promise<IGQLUser[]>((resolve, reject) => {

      const chainId = this.asvc.GetCurrentChainId()
      const branchId = this.asvc.GetCurrentBranchId()
      const formId = this.asvc.formId;

      if(!this.asvc.IsChainAssigned() || !this.asvc.IsBranchAssigned()) {
        return;
      }

      const i = this.cached.findIndex(lf => lf.chain_id == chainId && lf.branch_id == branchId);
      if(i >= 0) {
        resolve(this.cached[i].approvers);
        return;
      }

      this.loading.set(true)

      this.gql.query(
        //language=gql
        `
        query GetApprovers($chainId: Int, $branchId: Int, $formId: Int) {
          forms {
            form_predefined_approvers( form_id: $formId, chain_id: $chainId, branch_id: $branchId) {
              id
              first_name
              last_name
            }
          }
        }
      `,{chainId, branchId, formId}
      ).pipe(first()).subscribe({
        next: (r:HttpResponse<IGQLResponse<{forms:{form_predefined_approvers:IGQLUser[]}}>>) => {
          this.loading.set(false)
          const approvers = r.body.data.forms.form_predefined_approvers
          resolve(approvers);
          this.cached.push({
            chain_id: chainId,
            branch_id: branchId,
            form_id: formId,
            approvers,
            changed: false
          })
        }
      })

    })
  }

  public Sync(ids: number[]) {
    const chainId = this.asvc.GetCurrentChainId()
    const branchId = this.asvc.GetCurrentBranchId()

    const cache = this.cached.find(lf => lf.chain_id == chainId && lf.branch_id == branchId);

    if(cache) {
      this.sysvc.GetManagers(chainId)
        .then(managers => {
          cache.approvers = managers.filter(m => ids.includes(m.id)).map(m => {
            return {
              id: m.id,
              first_name: m.first_name,
              last_name: m.last_name
            } as IGQLUser
          })
          cache.changed = true;
        })
    }
  }

  public Save() {
    const chainId = this.asvc.GetCurrentChainId()
    const branchId = this.asvc.GetCurrentBranchId()
    const formId = this.asvc.formId;

    const cache = this.cached.find(lf => lf.chain_id == chainId && lf.branch_id == branchId)

    if(cache && cache.changed) {
      this.gql.query(
        //language=gql
        `
        mutation UpdateApprovers($chainId: Int, $branchId: Int, $formId: Int, $approvers: [Int]) {
          forms {
            approver(form_id: $formId, chain_id: $chainId, branch_id: $branchId, action: UPD, employees: $approvers) {
              user_id
            }
          }
        }
      `,{
          chainId,
          branchId,
          formId,
          approvers:cache.approvers.map(a => a.id)
        }
      ).pipe(first()).subscribe({
        next: () => {
          cache.changed = false;
        }
      })
    }

  }
}
